import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuebar from 'vuebar';
import VeeValidate from 'vee-validate'

Vue.config.productionTip = false

// Globally Reusable Mixin
Vue.mixin ({
	methods: {
		formatToPath: function(texttoformat) {
			return texttoformat.replace(" ", "-").toLowerCase();
		},
		toTitleCase: function(texttoformat) {
			return texttoformat.toLowerCase().split(' ').map(function(word) {
				return (word.charAt(0).toUpperCase() + word.slice(1));
			}).join(' ');
		},
		splitFromUpperCase: function(texttoformat) {
			return texttoformat.split(/(?=[A-Z])/).join(' ');
		},
		formatDate: function(date) {
			let monthNames = [
			"Jan", "Feb", "Mar",
			"Apr", "May", "Jun", "Jul",
			"Aug", "Sep", "Oct",
			"Nov", "Dec"
			];

			let day = date.getDate();
			let monthIndex = date.getMonth();
			let year = date.getFullYear();

			return day + ' ' + monthNames[monthIndex] + ' ' + year;
		},
		scrollToTop: function(scrollDuration) {
			var scrollStep = -window.scrollY / (scrollDuration / 15),
			scrollInterval = setInterval(function(){
				if ( window.scrollY != 0 ) {
					window.scrollBy( 0, scrollStep );
				}
				else clearInterval(scrollInterval); 
			},15);
		},
		reverseSerial: function (array,index) {
      return (array.length - index)
    },
		disableBodyScroll: function () {
			// Add .modal-open to Body
			document.body.classList.add("modal-open");
    },
		enableBodyScroll: function () {
			// Remove .modal-open from Body
			document.body.classList.remove("modal-open");
    }
	}
});

Vue.use(Vuebar);
Vue.use(VeeValidate, {
	// Uncomment In CRM
	events: ''
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
